export default __webpack_public_path__ + "static/share-card-a8c963bd9072029ec1d3b4aae4bfeafe.png";